// extracted by mini-css-extract-plugin
export default {"searchIconStyle":"styles_searchIconStyle__ziIvL","customPlaceholder":"styles_customPlaceholder__Vf8AB"};